import React, { useState } from 'react';
import { ClayInput } from '@clayui/form';
import { ClayButtonWithIcon } from '@clayui/button';
import ClayManagementToolbar from '@clayui/management-toolbar';
import { getCoordinationSettings } from '../../helpers/getCoordinationSettings';
import {getDigitalsaleForms} from "../../helpers/getDigitalsaleForms";

export const spritemap = window.location.protocol + '//' + window.location.host + '/o/classic-theme/images/clay/icons.svg';

export const SearcherCard = ({ cards, setCards, pagination, useAddCoordinationModal }) => {

    const { setDelta, setCur } = pagination();

    const { setAddCoordinationModal } = useAddCoordinationModal();
    const [products, setProducts] = useState([]);
    const [idsLista, setIdsLista] = useState([]);

    const handleAddCard = () => {

        getDigitalsaleForms('').then(myobjet => {

            setProducts(myobjet.data);

            setIdsLista(cards.data.map(item => item.formCode));

            setAddCoordinationModal({ visible: true, data: {'products':myobjet.data, 'idsLista': cards.data.map(item => item.formCode)}});

        });
    }

    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            handleSearch();
        }
    }

    const handleSearch = () => {
        setDelta(10);
        setCur(1);
        getCoordinationSettings(10, 1).then(cards => {
            setCards(cards);
        });
    }

    return (
        <>
            <ClayManagementToolbar>
                <ClayManagementToolbar.Item className="navbar-form navbar-form-autofit navbar-overlay navbar-overlay-sm-down" >
                    <ClayInput.Group>
                        <ClayInput.GroupItem>
                            <ClayInput
                                aria-label="Search"
                                className="form-control input-group-inset input-group-inset-after"
                                placeholder="Buscar por nombre"
                                type="text"
                                id="input"
                                name='input'
                                onKeyDown={handleKeyDown}
                            />
                            <ClayInput.GroupInsetItem after tag="span">
                                <ClayButtonWithIcon
                                    displayType="unstyled"
                                    symbol="search"
                                    spritemap={spritemap}
                                    onClick={(e) => { e.preventDefault(); handleSearch(); }}
                                />
                            </ClayInput.GroupInsetItem>
                        </ClayInput.GroupItem>
                    </ClayInput.Group>
                </ClayManagementToolbar.Item>

                <ClayManagementToolbar.ItemList>
                    <ClayManagementToolbar.Item>
                        <ClayButtonWithIcon
                            className="nav-btn nav-btn-monospaced"
                            spritemap={spritemap}
                            symbol="plus"
                            onClick={handleAddCard}
                        />
                    </ClayManagementToolbar.Item>
                </ClayManagementToolbar.ItemList>

            </ClayManagementToolbar>
        </>
    )
}